<template>
  <page-common type="img" :has-comments="hasComments" :detail="detail">
    <div class="m-header">
      <h2 class="title f-taj">{{detail.title}}</h2>
      <div class="info">
        <span class="time">{{getTime(detail.date)}}</span>
        <span class="authors" v-if="detail.authors">{{detail.authors}}</span>
        <span class="copyfrom" v-if="detail.source">{{detail.source}}</span>
      </div>
    </div>
    <div class="m-img" v-if="detail.type=='image'">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) of detail.medias" :key="index">
            <img :src="webp(item.image)" />
            <div class="summary tj">
              <pre class="f-pre">{{item.description}}</pre>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <news-related :list="detail.extend"></news-related>
    <comment-normal :comments="comments"></comment-normal>
  </page-common>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import imgMixin from "mixins/image";
import Swiper from "swiper/dist/js/swiper.js";
import PageCommon from "./page-common";
import NewsRelated from "./news-related";
import CommentNormal from "./comment-normal";
import "swiper/dist/css/swiper.css";
import api from 'src/constants/appapi'
import wx from "../services/weChatShare"

export default {
  mixins: [imgMixin],
  components: {
    PageCommon,
    NewsRelated,
    CommentNormal
  },
  data (){
    return{
      isSharePage:false,
    }
  },
  computed: {
    ...mapGetters({
      detail: "normal:detail",
      comments: "normal:comments",
      hasComments: "normal:hasComments"
    })
  },
  watch: {
    $route: function() {
      this.init({
        sysCode: this.$route.params.sysCode,
        categoryId: this.$route.params.categoryId,
        id: this.$route.params.id,
        isTimeLimit : this.$route.query.isTimeLimit
      });
    },
    detail: {
      handler (val) {           
        if (this.isSharePage) {
            // 微信分享
            const imgUrl = val.images?val.images[0]:'';
            const cover = val.cover || ''
            wx({
                title: val.title,
                // imgUrl: imgUrl || cover || '',
                // desc: val.description || ''
            },this)
        }
      },
      deep: true
    },
  },
  created() {
    this.init({
      sysCode: this.$route.params.sysCode,
      categoryId: this.$route.params.categoryId,
      id: this.$route.params.id,
      isTimeLimit : this.$route.query.isTimeLimit
    });
    window.appapi = api
    this.isSharePage = appapi.isSharePage()
  },
  updated() {
    this.$nextTick(function() {
      this.swiper = new Swiper(".p-img .swiper-container", {
        // autoplay: 3000,
        pagination:{
            el:'.swiper-pagination',
            clickable:true,
            type : 'fraction'
        },
        speed: 500,
        loop: true,
        autoHeight: true,
        autoplayDisableOnInteraction: false,
        paginationCustomRender: function(swiper, current, total) {
          return current + " / " + total;
        }
      });
      console.log(this.swiper,'swiper')
    });
  },
  beforeDestroy() {
    this.swiper.destroy();
  },
  methods: {
    ...mapActions({
      init: "normal:init"
    }),
    getTime(time) {
      let result = "";
      if (time) {
        result = time.substring(0, 10) + " " + time.substring(11, 16);
      }
      return result;
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~src/stylus/mixin';
@import '~src/styles/base.styl';
@import '~src/styles/page-img.styl';
@import '~src/styles/page-common.styl';
</style>


// WEBPACK FOOTER //
// page-img.vue?6304df88